import React from 'react'
import { HeroContainer, HeroBg, HeroLeftContainer, PhotoFrame, Img, HeroRightContainer, HeroInnerContainer, TextLoop, Title, NameUnderline, Span, ResumeButton } from './HeroStyle'
import HeroImg from '../../images/my_photo.jpg'
import Typewriter from 'typewriter-effect';
import { Bio } from '../../data/constants';
import HeroBgAnimation from '../HeroBgAnimation';
import { RoughBox, RoughUnderline, RoughDivider } from '../common/Rough';
import { ChalkDoodles } from '../common/Doodles';
import styled from "styled-components";
import GitHubIcon from "@mui/icons-material/GitHub";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

const SocialMediaIcons = styled.div`
  display: flex;
  margin-top: 1rem;
`;

const SocialMediaIcon = styled.a`
  display: inline-block;
  margin: 0 1rem;
  font-size: 1.5rem;
  color: ${({ theme }) => theme.text_primary};
  transition: color 0.2s ease-in-out;
  &:hover {
    color: ${({ theme }) => theme.primary};
  }
`;

const HeroSection = () => {
    return (
        <div id="about">
            <HeroContainer>
                <ChalkDoodles seedBase={5} count={10} />
                <HeroBg>
                    <HeroBgAnimation />
                </HeroBg>
                <HeroInnerContainer >
                    <HeroLeftContainer id="Left">
                        <Title>Hi, I am <br /> {Bio.name}</Title>
                        <NameUnderline>
                            <RoughUnderline height={18} strokeWidth={4} />
                        </NameUnderline>
                        <TextLoop>
                            I am a
                            <Span>
                                <Typewriter
                                    options={{
                                        strings: Bio.roles,
                                        autoStart: true,
                                        loop: true,
                                    }}
                                />
                            </Span>
                        </TextLoop>
                        <SocialMediaIcons>
                            <SocialMediaIcon href={Bio.GitHub} target="display"><GitHubIcon /></SocialMediaIcon>
                            <SocialMediaIcon href={Bio.twitter} target="display"><TwitterIcon /></SocialMediaIcon>
                            <SocialMediaIcon href={Bio.linkedin} target="display"><LinkedInIcon /></SocialMediaIcon>
                        </SocialMediaIcons>
                        <RoughBox inline roughness={2.4} strokeWidth={2} padding="10px 22px" style={{ marginTop: 18 }}>
                            <ResumeButton href={Bio.resume} target='display'>Check Resume</ResumeButton>
                        </RoughBox>
                    </HeroLeftContainer>

                    <HeroRightContainer id="Right">
                        <PhotoFrame>
                            <RoughBox roughness={2.6} strokeWidth={3} double padding="14px">
                                <Img src={HeroImg} alt="hero-image" />
                            </RoughBox>
                        </PhotoFrame>
                    </HeroRightContainer>
                </HeroInnerContainer>

            </HeroContainer>
            <RoughDivider height={26} style={{ maxWidth: 1200, width: '92%', margin: '0 auto' }} />
        </div>
    )
}

export default HeroSection